// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyD-9a-7bTnJknWVLy4LVIrL7EFgEfGyuTE",
  authDomain: "aidis2021.firebaseapp.com",
  projectId: "aidis2021",
  storageBucket: "aidis2021.appspot.com",
  messagingSenderId: "265255627389",
  appId: "1:265255627389:web:cdd86ad9e11897d865df14",
  measurementId: "G-P49HR4XHM9"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/aidis2021.appspot.com/o/'